import React from 'react';
import { Card, CardHeader, CardBody } from 'react-bootstrap';
import { formatDate } from '../../../../helper/formatDate';
import { getStatusBadge } from '../EnquiryList/enquiryUtils';
import { FollowUpBtn } from '../FollowUpBtn';

export const FollowUpTimelineCard = ({ report, refershReport }) => {
    if (!report) return null;

    const followups = report.followups || [];

    return (
        <Card className="border-0 shadow-sm rounded-3">
            <CardHeader className="py-3 px-4 border-bottom bg-light-subtle d-flex align-items-center justify-content-between">
                <h5 className="card-title mb-0 fs-15 fw-bold text-dark">Follow-Up History</h5>
                <span className="badge bg-soft-primary text-primary fs-11 px-2.5 py-1">
                    {followups.length} {followups.length === 1 ? 'Record' : 'Records'}
                </span>
            </CardHeader>
            <CardBody className="p-3 p-md-4">
                {followups.length > 0 ? (
                    <div className="d-flex flex-column gap-3">
                        {followups.map((item, index) => {
                            const status = getStatusBadge(item.status);
                            const isLatest = index === followups.length - 1;
                            const isPending = item.status === 'pending';

                            return (
                                <div key={item.id || index} className="card border shadow-sm rounded-3 mb-0 w-100">
                                    {/* Card Header: Created Date & Status */}
                                    <div className="card-header bg-light-subtle py-2 px-3 border-bottom d-flex align-items-center justify-content-between flex-wrap gap-2">
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="fw-bold text-dark fs-13">
                                                <i className="ri-calendar-event-line text-muted me-1" />
                                                {formatDate(item.created_at)}
                                            </span>
                                            {isLatest && (
                                                <span className="badge bg-soft-success text-success fs-10 px-1.5 py-0.5">
                                                    Latest Entry
                                                </span>
                                            )}
                                        </div>
                                        <span className={`badge bg-soft-${status.color} text-${status.color} fs-11 px-2.5 py-1 text-capitalize fw-semibold`}>
                                            {item.status === 'deleted' ? 'Not Interested' : item.status || 'Pending'}
                                        </span>
                                    </div>

                                    {/* Card Body: Remark Text */}
                                    <div className="card-body p-3">
                                        <div
                                            className="p-2.5 bg-light rounded border border-light-subtle fs-13 text-dark lh-base"
                                            style={{ whiteSpace: 'pre-wrap' }}
                                        >
                                            {item.remark || <span className="text-muted fst-italic">No conversation remarks recorded.</span>}
                                        </div>

                                        {/* Next Date & Follow Action */}
                                        <div className="d-flex align-items-center justify-content-between mt-2.5 pt-2 border-top border-light-subtle flex-wrap gap-2 fs-12">
                                            <div>
                                                {item.joining_date ? (
                                                    <span className="text-muted d-inline-flex align-items-center gap-1">
                                                        <i className="ri-time-line text-primary" />
                                                        <span>Next Follow-Up Date:</span>
                                                        <strong className="text-primary ms-1">
                                                            {formatDate(item.joining_date)}
                                                        </strong>
                                                    </span>
                                                ) : (
                                                    <span className="text-muted fst-italic">No next date scheduled</span>
                                                )}
                                            </div>

                                            {/* Action button if pending */}
                                            {isPending && (
                                                <div>
                                                    <FollowUpBtn
                                                        onSuccess={refershReport}
                                                        follow={{
                                                            ...item,
                                                            enquiry: { name: report.name, id: report.id, course: report.course }
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="text-center py-5">
                        <div className="avatar-sm mx-auto mb-3">
                            <span className="avatar-title rounded-circle bg-light text-muted fs-24">
                                <i className="ri-chat-history-line" />
                            </span>
                        </div>
                        <h6 className="fs-14 fw-semibold text-dark mb-1">No Follow-Up Records Found</h6>
                        <p className="text-muted fs-13 mb-0">No past conversation remarks or calls have been recorded yet.</p>
                    </div>
                )}
            </CardBody>
        </Card>
    );
};

export default FollowUpTimelineCard;
